// extracted by mini-css-extract-plugin
module.exports = {"content":"RemoveStruct_content__1FMpw","buttonStyle":"RemoveStruct_buttonStyle__1IxRM","sizeText16":"RemoveStruct_sizeText16__3EXSt"};